var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeworders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-4{fill:#ddffea}.cls-5{fill:#06a200}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16283",
    "data-name": "Group 16283",
    transform: "translate(-441 -178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5798",
    "data-name": "Rectangle 5798",
    transform: "translate(441 178)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_635",
    "data-name": "Ellipse 635",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(445 182)",
    style: {
      fill: "rgba(221,255,234,.5)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16298",
    "data-name": "Group 16298",
    transform: "translate(402.77 184.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16267",
    "data-name": "Group 16267",
    transform: "translate(55.7 8.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19952",
    "data-name": "Path 19952",
    d: "m67.879 34.54-.063-.148-1.309-.247-.052-.151a5.554 5.554 0 0 1-.247-1.837l.007-.157 1.2-.61.017-.133-1.012-.877.032-.158a5.69 5.69 0 0 1 .709-1.706l.086-.136 1.345.068.029-.038-.451-1.254.1-.121a5.564 5.564 0 0 1 1.455-1.146l.142-.077 1.135.722.152-.064.246-1.3.151-.052a5.66 5.66 0 0 1 1.835-.253l.162.005.611 1.2.12.015.853-1.007.16.033a5.425 5.425 0 0 1 1.247.464v-9.5L69.077 8.6H56.942A1.243 1.243 0 0 0 55.7 9.842V33.8a1.243 1.243 0 0 0 1.242 1.242h10.619z",
    transform: "translate(-55.7 -8.6)",
    style: {
      fill: "#0ecc07"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19953",
    "data-name": "Path 19953",
    className: "cls-4",
    d: "M107.2 94.877a.741.741 0 0 1-.7.777h-7.7a.741.741 0 0 1-.7-.777.741.741 0 0 1 .7-.777h7.7a.741.741 0 0 1 .7.777z",
    transform: "translate(-39.807 -80.27)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19954",
    "data-name": "Path 19954",
    className: "cls-4",
    d: "M113.471 157.877a.741.741 0 0 1-.7.777H98.8a.741.741 0 0 1-.7-.777.741.741 0 0 1 .7-.777h13.976a.741.741 0 0 1 .7.777z",
    transform: "translate(-39.807 -139.417)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19955",
    "data-name": "Path 19955",
    className: "cls-4",
    d: "M113.471 221.477a.741.741 0 0 1-.7.777H98.8a.741.741 0 0 1-.7-.777.741.741 0 0 1 .7-.777h13.976a.741.741 0 0 1 .7.777z",
    transform: "translate(-39.807 -199.127)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19956",
    "data-name": "Path 19956",
    className: "cls-4",
    d: "M113.575 285.077a.745.745 0 0 1-.7.777H98.8a.741.741 0 0 1-.7-.777.745.745 0 0 1 .7-.777h14.068a.745.745 0 0 1 .7.777z",
    transform: "translate(-39.807 -258.837)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19957",
    "data-name": "Path 19957",
    className: "cls-4",
    d: "M110.57 348.677c0 .428-.257.777-.575.777h-11.42c-.318 0-.575-.349-.575-.777 0-.428.257-.777.575-.777h11.42c.318 0 .575.349.575.777z",
    transform: "translate(-39.713 -318.546)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19958",
    "data-name": "Path 19958",
    className: "cls-5",
    d: "M281.868 16.068h-5.976a1.491 1.491 0 0 1-1.492-1.492V8.6",
    transform: "translate(-205.323)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19959",
    "data-name": "Path 19959",
    className: "cls-5",
    d: "M245.235 285.533a5.249 5.249 0 0 0-.221-1.656l-1.236-.233v.006c-.052-.134-.111-.268-.169-.4l.682-1.073a4.2 4.2 0 0 0-1.189-1.312l-1.341.426v.006a.215.215 0 0 0-.1-.2l.146-1.271a5.082 5.082 0 0 0-1.5-.635l-.8.95.012.006a4.37 4.37 0 0 0-.4-.052l-.577-1.131a5.149 5.149 0 0 0-1.656.227l-.233 1.23h.006c-.14.052-.268.1-.4.169l-1.073-.682a5.07 5.07 0 0 0-1.312 1.032l.426 1.183h.006c-.07.087-.134.169-.2.262l-1.271-.064a5.189 5.189 0 0 0-.641 1.539l.95.822.006-.006a4.455 4.455 0 0 0-.052.408l-1.131.577a5.059 5.059 0 0 0 .222 1.656l1.236.233v-.006c.052.134.111.268.169.4l-.682 1.073a6.421 6.421 0 0 0 .933 1.312l1.078-.426v-.003c0 .07.268.134.361.2l-.017 1.271a5.083 5.083 0 0 0 1.568.635l.834-.95v-.006c.134.023.274.041.408.052l.583 1.131a5.249 5.249 0 0 0 1.656-.222l.233-1.23-.006-.006c.14-.052.274-.111.4-.169l1.073.682a4.87 4.87 0 0 0 1.312-1.073l-.426-1.224h-.006c.07 0 .134-.128.2-.221l1.271.087a5.189 5.189 0 0 0 .641-1.533l-.95-.816-.006.012a4.74 4.74 0 0 0 .052-.408zm-6.64 2.874a2.81 2.81 0 1 1 2.81-2.81 2.811 2.811 0 0 1-2.81 2.81",
    transform: "translate(-165.144 -253.497)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeworders);
export default __webpack_public_path__ + "static/media/neworders.d80869d1ac6b682025df55d2310607bf.svg";
export { ForwardRef as ReactComponent };